import { combineReducers } from 'redux';
import data from './app-data';
import widgets from './widgets';

export default combineReducers({
    widgets,
    data
});